// import Vue from 'vue'
import Vue from 'vue'
import {
  ADD_CONTACT,
  REQUEST_ADD_CONTACT,
  UPDATE_CONTACT,
  REQUEST_UPDATE_CONTACT,
  DELETE_CONTACT,
  REQUEST_DELETE_CONTACT,
  GET_CONTACT,
  GET_CONTACTS,
  GET_PROJECTS,
  GET_SOCIAL_STATUSES_OF_CONTACT,
  GET_PROBLEMATIQUES_OF_CONTACT,
  ERROR_XHR
  // SUCCESS_XHR
} from '../mutation-types.js'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getContacts = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http
        .get('contactList')
        .then(
            (response) => {
              dispatch(GET_CONTACTS, response.json())
              resolve()
            },
            (response) => {
              dispatch(ERROR_XHR, response.json())
              reject()
            })
  })
}

/**
 * Get single Contact
 *
 * @param store
 * @param contactId
 * @returns {Promise}
 */
/*
export const getContact = (store, contactId) => {
  const sortContacts = (contacts, contactId) => contacts.filter((contact) => Number(contact.id) === Number(contactId))[0]

  if (!store.state.contacts.all.length) {
    return getContacts(store).then(() => store.dispatch(GET_CONTACT, sortContacts(store.state.contacts.all, contactId)))
  }

  return new Promise((resolve, reject) => {
    store.dispatch(GET_CONTACT, sortContacts(store.state.contacts.all, contactId))
    resolve()
  })
}
*/
export const getContact = (store, contactId) => {
  return new Promise((resolve, reject) => {
    Vue.http
        .get('contactById/' + contactId)
        .then(
            (response) => {
              store.dispatch(GET_CONTACT, response.json())
              resolve()
            },
            (response) => {
              store.dispatch(ERROR_XHR, response.json())
              reject()
            })
  })
}

export const getSocialStatusByContact = ({ dispatch }, contactId) => {
  dispatch(GET_SOCIAL_STATUSES_OF_CONTACT)
  console.log('getSocialStatusByContact ' + contactId)
  return new Promise((resolve, reject) => {
    Vue.http.get('social_status/' + contactId)
      .then(
        (response) => {
          console.log('getSocialStatusByContact Reponse ' + response.json())
          dispatch(GET_SOCIAL_STATUSES_OF_CONTACT, response.json())
          resolve()
          // return response.json()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          console.log('getSocialStatusByContact Reject ' + response.json())
          reject()
        })
  })
}

export const getProblematiqueByContact = ({ dispatch }, contactId) => {
  dispatch(GET_PROBLEMATIQUES_OF_CONTACT)
  console.log('getProblematiqueByContact ' + contactId)
  return new Promise((resolve, reject) => {
    Vue.http.get('problematique/' + contactId)
      .then(
        (response) => {
          console.log('getProblematiqueByContact Reponse ' + response.json())
          dispatch(GET_PROBLEMATIQUES_OF_CONTACT, response.json())
          resolve()
          // return response.json()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          console.log('getProblematiqueByContact Reject ' + response.json())
          reject()
        })
  })
}

/**
 * getProjectsOfContact
*/
export const getProjectsOfContact = (store, contactId) => {
  console.log('getProjectsOfContact ' + contactId)
  return new Promise((resolve, reject) => {
    Vue.http
	.get('projectsOfContactById/' + contactId)
        .then(
            (response) => {
              // console.log('getProjectsOfContact Reponse ' + response.json())
              store.dispatch(GET_PROJECTS, response.json())
              resolve()
              // return response.json()
            },
            (response) => {
              // store.dispatch(ERROR_XHR, response.json())
              console.log('getProjectsOfContact Reject ' + response.json())
              reject()
            })
  })
}

export const getProjectsOfContactR = (contactId) => {
  console.log('getProjectsOfContactR ' + contactId)
  return new Promise((resolve, reject) => {
    Vue.http
	.get('projectsOfContactById/' + contactId)
        .then(
            (response) => {
              // console.log('getProjectsOfContactR Reponse ' + response.json())
              return response.json()
            },
            (response) => {
              reject()
            })
  })
}

/**
 * Add a new contact
 * @param dispatch
 * @param contact
 */
export const addContact = ({ dispatch }, contact) => {
  dispatch(REQUEST_ADD_CONTACT)
  Vue.http
    .post('contact', contact)
    .then(
      (response) => {
        let data = JSON.parse(response.data)
        dispatch(ADD_CONTACT, data.contact)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}

/**
 * Edit a contact
 *
 * @param dispatch
 * @param oldContact The former contact data
 * @param newContact The new contact data
 */
export const editContact = ({ dispatch }, oldContact, newContact) => {
  dispatch(REQUEST_UPDATE_CONTACT)
  Vue.http
    .put('contact/' + newContact.id, newContact)
    .then(
      (response) => {
        dispatch(UPDATE_CONTACT, oldContact, newContact)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
)
}

/**
 * Delete a user
 *
 * @param dispatch
 * @param user
 */
export const deleteContact = ({ dispatch }, contact) => {
  dispatch(REQUEST_DELETE_CONTACT, contact)
  Vue.http.delete('contact/' + contact.id)
    .then(
      (response) => {
        dispatch(DELETE_CONTACT, contact)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}



// WEBPACK FOOTER //
// ./src/vuex/actions/contactActions.js